import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import client from '@/api/client';
import { BASE_URL } from '@/constants';

import moment from 'moment';

export default {
	postSearchSelectList: param => {
		return client
			.get(`${BASE_URL}/comm/common/custCode/v1/carSaleCustCodeLists`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	// custom 코드조회
	async getCommCodeDetails(codeType) {
		try {
			const params = { commCdType: codeType, sqlId: 'customPrCorSql', commCd: '', refCd: '' };
			const queryString =
				'?' +
				Object.entries(params)
					.map(([key, val]) => (!_.isNil(val) ? `${key}=${val}` : ''))
					.filter(r => r)
					.join('&');

			const response = await client.get(`${BASE_URL}/comm/common/custCode/v1/custCodeLists` + queryString);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	getCarSaleList: ({ searchParams, currentPage, pageUnit }) => {
		//Fe단으로 넘길 파라미터,페이징처리
		let queryStr = '';
		let srchMm03 = searchParams.srchMm03;

		/*날짜 포멧변환*/
		var strtMm01, endMm01;

		//console.log('값은>>>>', searchParams);

		if (searchParams.strtMm01) {
			strtMm01 = moment(searchParams.strtMm01).format('YYYYMMDD');
		} else {
			strtMm01 = '';
		}
		if (searchParams.endMm01) {
			endMm01 = moment(searchParams.endMm01).format('YYYYMMDD');
		} else {
			endMm01 = '';
		}

		queryStr = objectToQuerystring({
			pmcId: searchParams.pmcId, //pmcId
			pmcNo: searchParams.pmcNo, //pmcNo
			flclSpc: searchParams.flclSpc, //flclSpc
			saleRegn: searchParams.saleRegn, //saleRegn
			carVin: searchParams.carVin, //carVin
			carScn: searchParams.carScn, //carScn
			srchMm03: searchParams.srchMm03, //srchMm03
			pwrType: searchParams.pwrType, //동력유형
			pacScn: searchParams.pacScn, //승상구분
			carTypeNm: searchParams.carTypeNm,
			strtMm01: strtMm01, //strtMm01
			endMm01: endMm01, //endMm01
			currentPage,
			pageUnit,
			idxScn:searchParams.idxScn,
			licensePlate:searchParams.licensePlate
		});

		//Fe단으로 보내는 url
		return client
			.get(`${BASE_URL}/mqy/qlty/carSale/v1/carSales` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	async excelTempDown(params) {
		// 엑셀템플릿 다운로드
		try {
			const response = await client.post(`${BASE_URL}/comm/common/qmsFileInfo/v1/downExcelTemp`, params, {
				responseType: 'blob'
			});
			return response;
		} catch (error) {
			throw error.response?.data;
		}
	}
};
